"use client";

import Script from "next/script";

/**
 * kolaytik (JotForm) AI sohbet agent'ı — site geneli yüzen sohbet balonu.
 * Tüm görünüm/davranış ayarları (renk, karşılama, otomatik açılma, konum)
 * kolaytik panelinde tutulur ve embed.js'e sunucu tarafından gömülür;
 * burada yalnızca script yükleniyor.
 */
const AGENT_ID = "019f7a3b04a070008a0766765d82f96e09a2";
const EMBED_SRC = `https://panel.kolaytik.com/agent/embedjs/${AGENT_ID}/embed.js`;

export function AgentChat() {
  return <Script id="kolaytik-agent" src={EMBED_SRC} strategy="lazyOnload" />;
}
